import React from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import NeapolitanCard from './NeapolitanCard';

// Cosmetic-only sequence for an OPPONENT's capture (CPU or online opponent):
// the played card (gold ring) + captured card(s) appear together over the table
// (giocata + presa visibile), briefly hold, then sweep up toward the opponent's
// pile (raccolta). Purely visual: aria-hidden, no pointer events, no focus.
// Transform/opacity only. Total ~1.15s driven by the caller (mount ~0.35s in +
// ~0.45s hold, unmount ~0.35s out).
export function OpponentCaptureFx({ fx, testId = 'opponent-capture-fx' }) {
  return (
    <AnimatePresence>
      {fx && (
        <motion.div
          className="pointer-events-none absolute left-0 right-0 top-[38%] z-30 flex justify-center px-4"
          aria-hidden="true"
          data-testid={testId}
          initial={{ opacity: 0, y: -110, scale: 0.9 }}
          animate={{ opacity: 1, y: 0, scale: 1 }}
          exit={{ opacity: 0, y: -160, scale: 0.7 }}
          transition={{ type: 'tween', ease: 'easeOut', duration: 0.35 }}
        >
          <div className="flex items-center gap-2 rounded-2xl bg-black/45 backdrop-blur-[2px] px-3 py-2 shadow-[0_10px_24px_rgba(0,0,0,0.5)]">
            <div className="rounded-lg ring-2 ring-[#D4AF37]">
              <NeapolitanCard card={fx.played} sizeClass="w-14 sm:w-16" />
            </div>
            <span className="text-[#D4AF37] text-2xl font-bold px-0.5" aria-hidden="true">
              +
            </span>
            <div className="flex items-center gap-1.5">
              {fx.captured.map((c) => (
                <NeapolitanCard key={c.id} card={c} sizeClass="w-14 sm:w-16" />
              ))}
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}

export default OpponentCaptureFx;
